import { Select } from "antd";
import React from "react";

function MedAgent({callingData, selectedMedAgent, setSelectedMedAgent}) {

  return (
    <div>
      <Select
        placeholder="Select roles"
        onChange={(data)=>setSelectedMedAgent(data)}
        style={{ width: "200px" }}
        optionFilterProp="label"
        value={selectedMedAgent}
        showSearch
      >
        {callingData?.map((role) => (
          <Option key={role?.agent_name} label={role?.agent_name} value={role?.agent_id}>
            {role?.agent_name}
          </Option>
        ))}
      </Select>
    </div>
  );
}

export default MedAgent;
